import { useEffect, useContext } from "react";
import { AuthContext } from "../App";
import { Navigate } from "react-router-dom";

function Logout() {
    const { logout } = useContext(AuthContext);

    useEffect(() => {
        logout();
    }, [logout]);

    return <Navigate to="/login" replace />;
}

export default Logout;
